import { AxiosResponse } from "axios";
import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import * as service from "./service";
import * as types from "./types";
import * as alert from "../alert/actions";
import * as actions from "./actions";

function* postOverrideRequestSaga({ payload }: types.PostOverrideRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPostOverrideRequestSuccess[] | types.IApiError> = yield call(service.postOverrideRequest, payload);

        if (response.status === 201) {
            let dataPayload = response.data as types.IPostOverrideRequestSuccess[];
            yield put(
                actions.postOverrideSuccess({
                    override: dataPayload,
                })
            );
            let requestIds = dataPayload.map((data) => data.requestId).join(',');
            let successMsg = dataPayload.length > 1 ? `The Override Request were successfully created, with Override Request IDs: ${requestIds}. Timestamp: ${timestamp}` : `The Override Request were successfully created, with Override Request IDs: ${requestIds}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
        }

        if (response.status !== 201) {
            let apiError = response.data as types.IApiError;
            let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));
        }
    } catch (e: any) {
        yield put(
            actions.postOverrideFailure({
                error: e,
            })
        );
    }
}

function* createOverrideRequestSaga() {
    yield takeLatest(actionTypes.POST_OVERRIDEREQUEST_REQUEST, postOverrideRequestSaga);
}

function* patchOverrideRequestSaga({ requestId, payload }: types.PatchOverrideRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPatchOverrideRequestSuccessPayload | types.IApiError> = yield call(service.patchOverrideRequest, requestId, payload);

        if (response.status === 204) {
            yield put(
                actions.patchOverrideSuccess({
                    isSuccess: true,
                })
            );
            let successMsg = `The Override request status was successfully updated to: ${payload.status}. Request ID: ${requestId}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
        }

        if (response.status !== 204) {
            let apiError = response.data as types.IApiError;
            let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));
        }
    } catch (e: any) {
        yield put(
            actions.patchOverrideFailure({
                error: e,
            })
        );
    }
}

function* patchOverrideReqSaga() {
    yield takeLatest(actionTypes.PATCH_OVERRIDEREQUEST_REQUEST, patchOverrideRequestSaga);
}

function* fetchOverrideRequestDetailsSaga(action: types.FetchOverrideRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IOverrideRequestDetails | types.IApiError> = yield call(service.getOverrideRequestDetails, action.params);

        if (response.status === 200) {
            yield put(
                actions.getOverrideSuccess({
                    override: response.data as types.IOverrideRequestDetails,
                })
            );
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
            yield put(
                actions.getOverrideFailure({
                    error: response.data as types.IApiError,
                })
            );
        }

    } catch (e: any) {
        yield put(
            actions.getOverrideFailure({
                error: e,
            })
        );
    }
}

function* overrideRequestDetailsSaga() {
    yield takeEvery(actionTypes.FETCH_OVERRIDEREQUEST_REQUEST, fetchOverrideRequestDetailsSaga);
}

//Override List
function* fetchOverrideRequestListSaga(action: types.FetchOverrideRequestsReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IOverrideRequestList | types.IApiError> = yield call(service.getOverrideRequests, action.params);

        if (response.status === 200) {
            yield put(
                actions.fetchOverrideRequestsSuccess({
                    overrideRequests: response.data as types.IOverrideRequestList,
                })
            );
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
        }

    } catch (e: any) {
        yield put(
            actions.fetchOverrideRequestsFailure({
                error: e,
            })
        );
    }
}

function* overrideRequestListSaga() {
    yield takeLatest(actionTypes.FETCH_OVERRIDEREQUEST_LIST_REQUEST, fetchOverrideRequestListSaga);
}


function* overrideRequestSaga() {
    yield all([
        createOverrideRequestSaga(),
        patchOverrideReqSaga(),
        overrideRequestDetailsSaga(),
        overrideRequestListSaga()
    ])
}

export default overrideRequestSaga;